import './styles.css';
import { TfiHeadphoneAlt } from 'react-icons/tfi';
import { useContext } from 'react';
import { ContactInfoModal, MyProjectsModal } from 'components';
import { useModalState } from 'hooks';
import { ProjectsContext } from 'contexts/projectsContext';
import { FolderFull } from 'assets/icons/file';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const { t } = useTranslation();
  const [isContactInfoOpen, openContactInfo, closeContactInfo] =
    useModalState(false);
  const [isMyProjectsModalOpen, openMyProjectsModal, closeMyProjectsModal] =
    useModalState(false);
  const { currentProject, currentConfiguration } = useContext(ProjectsContext);

  return (
    <nav>
      <img
        src="https://wibe-group.com/storage/749395E8DEFD0E93C597901FCBE2FB28C7F470E68E29621BFCAF64B8911548F1/61ed44c30b054aef94fe58070acc7160/png/media/be0ebfc079464a679e984d17209ad4ec/Stago%20Logo.png"
        alt=""
      />
      <div onClick={openContactInfo}>
        <TfiHeadphoneAlt />
        {t('header.contact.support')}
      </div>
      <div>
        {currentProject && (
          <>
            {currentProject?.name} / {currentConfiguration?.name}
          </>
        )}
        <div className="my-projects center-xy" onClick={openMyProjectsModal}>
          <FolderFull />
        </div>
        {t('global.my.projects')}
      </div>

      <ContactInfoModal isOpen={isContactInfoOpen} onClose={closeContactInfo} />
      <MyProjectsModal
        isOpen={isMyProjectsModalOpen}
        onClose={closeMyProjectsModal}
      />
    </nav>
  );
};

export default Navbar;
